import React from "react";
import SignInPage from "../Components/SignIn/SignInPage";
import ScrollToTop from "../Components/ScrollToTop";

function SignIn() {
  return (
    <>
      <ScrollToTop />
      <SignInPage />
    </>
  );
}

export default SignIn;
